import React, {useEffect, useRef,useState } from "react"; 
import { Button, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import {getCategoryDetails} from "../../../../Services/CategoryServices"
import {getEnvUrl} from "../../../../utils/Api"
const ViewCategory = ({  viewDataid,isShow,close }) => {  
  const handleShow = () => setShow(true);
  const handleClose = () => {setShow(false);close()};
  const [show, setShow] = useState(false);
  const [categoryData, setCategoryData] = useState(false);
  useEffect(() => { 
    getCategoryDetails(viewDataid).then((data)=>{
      if(data.status){
        console.log(data.data)
        setCategoryData(data.data)
      }
    })
    setShow(isShow)
  }, []); 
  return ( 
    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <h5 className="modal-title">Category</h5>
        </Modal.Header>
        <Modal.Body>
        <form className="row g-3">
            <div className="col-12 px-3">
              <label for="updateGameSubject" className="form-label">Subject : </label>
               <span id="vSubject">{categoryData?.gamesubject?.name}</span>
            </div>
            <div className="col-12 px-3">
              <label for="vGameCategoryName" className="form-label">Name : </label>
              <span id="vGameCategoryName">{categoryData?.name}</span> 
            </div>
            <div className="col-12 px-3">
              <label for="ordernumber" className="form-label">Order number : </label>
              <span id="vOrdernumber">{categoryData?.order}</span> 
            </div>
            <div className="col-12 px-3">
              <label for="categoryIcon" className="form-label">Icon : </label>
              <span id="vcategoryIcon"><img width="80" src= {`${getEnvUrl()}/game/getlevelimage?id=${categoryData?.level_id}&hash=${Date.now()}`}
             
              
              /></span> 
            </div>
          </form> 
        </Modal.Body> 
      </Modal>
       
  );
};

export default ViewCategory;

